// extracted by mini-css-extract-plugin
export default {"LandingPage":"LandingPage_LandingPage__BzIhg","LandingPageHero":"LandingPage_LandingPageHero__DK83Y"};